import React, { useEffect,useContext } from 'react'
import ScrollToTop from '../../../Shared/ScrollToTop';
import { NavLink } from 'react-router-dom';
import AvailabeLeaveImg from '../../../../assets/images/weerp/web-image/branch/available-leave.png';
import ApplyLeaveImg from '../../../../assets/images/weerp/web-image/branch/apply-leave.png';
import { ProjectTypeContext } from '../../../../ContextHandle';
export default function Hrm({ setActivePage, sectionRefs,setDefaultWebActiveMenu }) {
     /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(1030);
        document.title = 'HR Management | ' + projectName + ' web';
        setDefaultWebActiveMenu(3);
    }, [projectName]);
    return (
        <div className='d-flex flex-column justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div className=" right-content-box-width">
                <nav  >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">Branch Panel</li>
                        <li className="breadcrumb-item active" aria-current="page">HRM</li>
                    </ol>
                </nav>
                <div id="accounts" ref={sectionRefs['25']}>
                    <h3 className="mt-3 pt-2">HRM</h3>
                    <h4 className="mt-5  ">Available leave</h4>
                    <p> Branch employees can see their available leave. he can Apply for leave. </p>
                    <div className='pt-3'> 
                        <img src={AvailabeLeaveImg} className="w-100 rounded" alt="availableleave.png"></img>
                    </div>
                    <h4 className="border-top mt-5 pt-5">Apply Leave</h4>
                    <div className='pt-3'> 
                        <img src={ApplyLeaveImg} className="w-100 rounded" alt="applyleave.png"></img>
                    </div>
                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/branch/accounts`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Accounts</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/branch/reports`} className="text-decoration-none">
                            <a href="#login" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Reports</h4>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}
